import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16d8eba4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-page p-filled" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Đăng nhập")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Đăng nhập bằng tài khoản Google để truy cập trang quản lý ", -1 /* HOISTED */))
const _hoisted_4 = { class: "p-d-flex p-jc-between p-filled" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _hoisted_2
      ]),
      content: _withCtx(() => [
        _hoisted_3
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_Button, {
            label: "Đăng nhập với Google",
            icon: "pi pi-google",
            class: "p-button-danger",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.doLoginWithGoogle())),
            loading: $setup.isLoading
          }, null, 8 /* PROPS */, ["loading"])
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}